import { NgModule } from '@angular/core';
import { LibContactBubbleIconComponent } from './lib-contact-bubble-icon.component';

@NgModule({
  declarations: [LibContactBubbleIconComponent],
  exports: [LibContactBubbleIconComponent],
})
export class LibContactBubbleIconModule {}
